<template>
  <div class="skin-cases">
    <div v-if="currW > 525" class="cases">
      <NuxtLink
          v-for="itemCase in cases?.slice(0, (compressed ? 3 : 5))"
          :key="itemCase.market_hash_name"
          v-tooltip="t('named_case', {name: itemCase?.market_hash_name?.replace('Case', '')})"
          :to="getItemLink({name: itemCase.market_hash_name, slug: itemCase.link})"
          class="skin-case"
      >
        <img
            :alt="itemCase.market_hash_name"
            :src="getImageFromWaxpeer(itemCase.market_hash_name || '', '100:100')"
            class="case-img"
            height="26"
            loading="lazy"
            width="26"
        />
      </NuxtLink>
      <div
          v-if="cases?.length > (compressed ? 3 : 5)"
          class="skin-case case-number"
          @mouseleave="showAllCases = false"
          @mouseover="showAllCases = true"
      >
        <span>+{{ cases?.length - (compressed ? 3 : 5) }}</span>
      </div>
    </div>
    <div
        :class="{ showAllCases: showAllCases }"
        class="all-cases"
    >
      <NuxtLink
          v-for="itemCase in cases"
          :key="itemCase"
          v-tooltip="t('named_case', {name: itemCase.market_hash_name?.replace('Case', '')})"
          :aria-label="itemCase"
          :to="getItemLink({name: itemCase.market_hash_name, slug: itemCase.link})"
          class="skin-case"
      >
        <img
            :src="getImageFromWaxpeer(itemCase.market_hash_name || '', '100:100')"
            alt=""
            class="case-img"
            loading="lazy"
        />
      </NuxtLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useI18n} from "vue-i18n";
import {getImageFromWaxpeer} from "~/utils/get-image-url";
import type {CratesItem} from "~/graphql/generated/schema-types";

const props = defineProps<{
  cases: CratesItem[]
  compressed: boolean
}>()

const currW = useResize()
const {t} = useI18n()
const showAllCases = ref(false)
</script>

<style lang="scss" scoped>
.skin-cases {
  display: flex;
  gap: 0.4rem;
  height: 4rem;
  position: relative;
  z-index: 2;

  .cases {
    display: flex;
    gap: 0.4rem;
    height: 100%;
  }

  .skin-case {
    background: rgba(133, 113, 255, 0.1);
    border-radius: 8px;
    min-width: 4rem;
    min-height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;

    .case-img {
      width: 3rem;
    }
  }

  .case-number {
    font-weight: 500;
    font-size: 1.2rem;
    line-height: 1.6rem;

    color: var(--accent-secondary);
  }
}

.all-cases {
  position: absolute;
  display: none;
  flex-wrap: wrap;
  gap: 0.4rem;
  width: calc(100% + 1.6rem);
  background: var(--surfaces-low-container);
  box-shadow: 0 0 3rem #10141a;
  border-radius: 1.2rem;
  padding: 0.8rem;
  z-index: 10;
  top: -0.8rem;
  left: -0.8rem;
  height: fit-content;

  @media screen and (max-width: 525px) {
    display: flex;
    max-width: 100%;
    flex-wrap: nowrap;
    overflow-y: hidden;
  }

  &:hover {
    display: flex;
  }
}

.showAllCases {
  display: flex;
}
</style>
